module.exports = __webpack_public_path__ + "assets/Retina-BookItalic.d3b61810633aa3471ae8d965f6741b45.woff";